import { render, staticRenderFns } from "./SuggestionCommentActions.vue?vue&type=template&id=1af849a0"
import script from "./SuggestionCommentActions.vue?vue&type=script&lang=js"
export * from "./SuggestionCommentActions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports